<script setup lang="ts">
import { computed } from 'vue'
import { useModalStore } from '@/stores/ModalStore'
import UeModal from '@components/base/UeModal.vue'

const modalStore = useModalStore()

const modalParams = computed(() => modalStore.getModalParams('logo_search_modal') || {})
const title = computed(() => modalParams.value.title || 'Search and pick logos')
</script>

<template>
  <UeModal
    :adaptative="true"
    :title="title"
    name="logo_search_modal"
    ref="logoSearchModal"
    width="50%"
  >
    <div class="row">
      <div class="col-md-3">
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Recipient's username"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          />
        </div>
        <button class="btn btn-primary">Search logos</button>
      </div>
      <div class="col-md-9"></div>
    </div>
  </UeModal>
</template>
